import React from "react";

const CheckboxLabel = ({ text, className, onClick, htmlFor, checked, style }) => {
    const classBackground = checked ? '!bg-yellow-200' : '';
    const labelClassName = `cursor-pointer ml-[8px] whitespace-nowrap ${className || ''} ${classBackground}`;
    return (
        <label className={labelClassName} onClick={onClick} htmlFor={htmlFor} style={style}>
            {text}
        </label>
    );
};

export default CheckboxLabel